/** Shape del payload biométrico para tarjeta RFID/HID.
 * Almacenado en biometric_data[].biometric_data cuando id_template_biometric !== 14 && !== 5. */
export interface CardBiometricData {
  decimal: string;
  card_number: number;
  format_card: string;
  decimal_short: number;
  facility_code: number;
}

/** Type guard: devuelve true si `v` es un objeto CardBiometricData.
 * Evita any-casts en el lookup. */
export function isCardBiometricData(v: unknown): v is CardBiometricData {
  return (
    v !== null &&
    typeof v === 'object' &&
    !Array.isArray(v) &&
    'card_number' in v
  );
}

export interface BiometricDataDTO {
  nro_biometric: number;
  biometric_data: number[] | string[] | { photo: string } | CardBiometricData;
  id_template_biometric: number;   // 14=face/photo, 5=PIN, other=card
  metadata: unknown[];
  id_entity_biometric?: number | undefined;
  id_entity?: number | undefined;
  at_created?: string | undefined;
}

export interface StructureInfoDTO {
  id_structure: number;
  code: string;
  /** Hierarchical path. Optional — not always returned by the backend. */
  path?: string | undefined;
  structure: string;   // e.g. 'VENEZUELA', 'INGENIERO DE SOLUCIONES'
  /** Optional — not always returned by the backend. */
  id_timezone?: number | undefined;
  id_structure_type: number;
  /** Optional — not always returned by the backend. */
  timezone_pg?: string | undefined;
  /** Human-readable structure type label, e.g. 'CARGO', 'DEPARTAMENTO', 'SEDE'. */
  structure_type?: string | undefined;
}

export interface EmployeeDTO {
  id_person: number;
  dui_person: string;
  first_name: string;            // ALL CAPS
  middle_name: string | null;
  last_name1: string;
  last_name2: string | null;
  email: string;                 // ALL CAPS
  cell_phone: string;
  photo: string | null;
  photo_rekognition: string | null;
  id_document_type: number;
  gender: 1 | 2;                 // 1=male, 2=female
  id_entity: number;
  code: string;
  entity_type: 'EMPLEADOS' | string;
  id_contract_type: number;
  status: 0 | 1;
  structures: number[];
  admin_device: 0 | 1;
  documentType: 'CEDULA' | string;  // sic — camelCase from backend
  structuresInfo: StructureInfoDTO[];
  biometric_data: BiometricDataDTO[];
  /** Legacy 128-d FaceNet embedding. NOT used for matching — use person_embed_v2. */
  person_embed: number[] | null;
  /** V2 512-d MobileFaceNet/ArcFace embedding. Used for local facial matching. Optional until backend adds support. */
  person_embed_v2?: number[] | null;
}

export interface EmployeeListResponseDTO {
  status: string;
  message: string;
  data: {
    results: EmployeeDTO[];
    count: number;
  };
}
